import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Invoices from './pages/Invoices';
import Drivers from './pages/Drivers';
import RoutePlanner from './pages/RoutePlanner';
import PortalActivity from './pages/PortalActivity';
import Analytics from './pages/Analytics';
import ManagementReport from './pages/ManagementReport';
import DriverReports from './pages/DriverReports';
import OdometerReport from './pages/OdometerReport';
import LiveMap from './pages/LiveMap';
import Rescheduled from './pages/Rescheduled';
import UserManagement from './pages/UserManagement';
import InvoiceTracking from './pages/InvoiceTracking';
import BcReconciliation from './pages/BcReconciliation';
import Layout from './components/Layout';

const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  return token ? children : <Navigate to="/login" />;
};

export default function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-right" />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<PrivateRoute><Layout /></PrivateRoute>}>
          <Route index element={<Dashboard />} />
          <Route path="invoices" element={<Invoices />} />
          <Route path="drivers" element={<Drivers />} />
          <Route path="route-planner" element={<RoutePlanner />} />
          <Route path="analytics" element={<Analytics />} />
          <Route path="management-report" element={<ManagementReport />} />
          <Route path="bc-reconciliation" element={<BcReconciliation />} />
          <Route path="live-map" element={<LiveMap />} />
          <Route path="driver-reports" element={<DriverReports />} />
          <Route path="odometer-report" element={<OdometerReport />} />
          <Route path="rescheduled" element={<Rescheduled />} />
          <Route path="tracking" element={<InvoiceTracking />} />
          <Route path="users" element={<UserManagement />} />
          <Route path="activity" element={<PortalActivity />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
